import { SOURCE_TYPES } from 'constants/source'

const METASEARCH_TRAFFIC_SOURCE_TYPES: ReadonlyArray<string> = [
  SOURCE_TYPES.METASEARCH,
  SOURCE_TYPES.LOGGEDIN_METASEARCH,
  SOURCE_TYPES.CUG_METASEARCH,
  SOURCE_TYPES.METASEARCH_SESSION,
  SOURCE_TYPES.METASEARCH_PRICE_VERIFIER,
]

export function isMetasearchRateSource(source?: string): boolean {
  const sourceTypes = source?.split(',') ?? []

  return sourceTypes.includes(SOURCE_TYPES.METASEARCH) || sourceTypes.includes(SOURCE_TYPES.CUG_METASEARCH)
}

/**
 * Whether the source marks GHA/metasearch traffic in any of the forms `getSource` and
 * `ghaPricedRequest` write. Wider than `isMetasearchRateSource`, which only asks for the
 * metasearch rate types.
 */
export function isMetasearchTrafficSource(source?: string): boolean {
  return !!source?.split(',').some(sourceType => METASEARCH_TRAFFIC_SOURCE_TYPES.includes(sourceType))
}
